import apiClient from '../index';

const paymentApi = {
  // Start gateway payment
  initiatePayment: (data) => {
    return apiClient.post('/payment/initiate', data);
  },

  // Charge selected mobile money network
  chargePayment: (data) => {
    return apiClient.post('/payment/charge', data);
  },

  // Gateway payment confirmation (webhook)
  verifyWebhook: (data) => {
    return apiClient.post('/payment/webhook-verify', data);
  }, 
// List payments for active event
  getEventPayments: (params) => {
    return apiClient.get('/payment/event-payments', { params });
  },
  // Alias for event payments
  getEventPayment: (params) => {
    return apiClient.get('/payment/event-payment', { params });
  },

  // List all payments
  getPayments: (params) => {
    return apiClient.get('/payment', { params });
  },

  // Show single payment
  getPayment: (paymentId) => {
    return apiClient.get(`/payment/${paymentId}`);
  },

  // Update payment
  updatePayment: (paymentId, data) => {
    return apiClient.put(`/payment/${paymentId}`, data);
  },
  
  // Check transaction status for initiated payments
  checkPaymentStatus: (paymentId) => {
    return apiClient.get(`/payment/check-status/${paymentId}`);
  },
  
  // Backwards compatibility for old createPayment if still used elsewhere
  createPayment: (data) => {
    return apiClient.post('/payment/initiate', data);
  },

  // Re-trigger mobile money push notification for a pending payment
  retryPayment: (transtoken) => {
    return apiClient.post('/payment/retry', { transtoken });
  }
};

export default paymentApi;